export default function SelectStation({station, setStation, onFetch}) {

    const onChange = e => {
        e.preventDefault();
        setStation(e.target.value)
    };

    const onSubmit = e => {
        e.preventDefault();
        onFetch();
    };

    return (
        <>
            <h1><span className="live-dot"/>Live podgląd stanów zbiorników</h1>
            <form className="supplies-controls" onSubmit={onSubmit}>
                <select onChange={onChange} defaultValue={station}>
                    <option value="AX001">Świdnica, Towarowa 24</option>
                    <option value="AX002">Lubin, Ścinawska 20b</option>
                    <option value="AX003">Legnica, Piłsudskiego 70</option>
                </select>
                <button type="submit" className="btn-pobierz">Pobierz dane</button>
                <div className="supplies-legend">
                    <span className="legend-item">
                        <svg width="12" height="12"><rect width="12" height="12" rx="2" fill="rgba(100, 160, 200, 0.4)" stroke="rgba(100, 160, 200, 0.8)" strokeWidth="1"/></svg>
                        stan rzeczywisty
                    </span>
                    <span className="legend-separator">|</span>
                    <span className="legend-item">
                        <svg width="24" height="10"><line x1="0" y1="5" x2="24" y2="5" stroke="#27ae60" strokeWidth="2" strokeDasharray="4 3"/></svg>
                        stan magazynowy
                    </span>
                    <span className="legend-separator">|</span>
                    <span className="legend-item">
                        <svg width="24" height="10"><line x1="0" y1="5" x2="24" y2="5" stroke="#e74c3c" strokeWidth="2" strokeDasharray="4 3"/></svg>
                        minimum zbiornika
                    </span>
                </div>
                <a className="btn-procedura" href="/procedura.pdf" target="_blank" rel="noopener noreferrer">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/>
                    </svg>
                    Procedura
                </a>
            </form>
        </>
    )
}
